import { Flex, Input } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import * as React from "react";
import { GetWSMgr } from "@/Utils/StateLib";
import { useAppendTableManagement } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/AppendTable/useAppendTableManagement";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useTableManagerContext } from "@/providers/AppendTableProvider";

export const GeneralTab = forwardRef(({ tableMgr, ...props }, ref) => {
  const wsMgr = GetWSMgr();
  const { validateTableName, handleManageTableAction } = useAppendTableManagement(wsMgr);

  const {
    tableManager,
    tableEditorContextValue: { showTableEditor }
  } = useTableManagerContext();
  const [defaultTableName, setDefaultTableName] = React.useState("");
  const [currentTableName, setCurrentTableName] = React.useState("");
  const [validation, setValidation] = useState({ status: "default", errorMsg: "", isValid: true });
  const [isDirty, setIsDirty] = useState(false);

  // Track changes to determine dirty state
  useEffect(() => {
    setIsDirty(defaultTableName !== currentTableName);
  }, [currentTableName, defaultTableName]);

  useEffect(() => {
    if (props.onValidityChange) {
      props.onValidityChange(validation.isValid);
    }
  }, [validation.isValid, props.onValidityChange]);

  useEffect(() => {
    setDefaultTableName(tableMgr.fTableInfo["name"]);
  }, [tableManager]);

  useImperativeHandle(ref, () => ({
    validate: async () => {
      return validation.isValid;
    },
    save: async () => {
      try {
        handleManageTableAction("rename", { ...tableMgr.fTableInfo, name: currentTableName });
        setIsDirty(false);
      } catch (error) {
        console.error("Error saving:", error);
        return false;
      }
    },
    checkValidity: async () => {
      return validation.isValid;
    },
    hasUnsavedChanges: async () => {
      return isDirty;
    }
  }));

  const inputRef = useRef(null);

  useEffect(() => {
    const startingName = tableMgr.fTableInfo["name"];
    setCurrentTableName(startingName);
    setDefaultTableName(startingName);
    setValidation({ status: "default", errorMsg: "", isValid: true });
    handleAutoInputSelect();
  }, [showTableEditor]);

  const handleInputChange = e => {
    const newName = e.target.value;
    setCurrentTableName(newName);
    setValidation(validateTableName(newName));
  };

  const handleAutoInputSelect = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 10);
  };

  return (
    <Flex height={"100%"} direction={"column"} gap={"4px"}>
      <Input
        ref={inputRef}
        require
        onChange={handleInputChange}
        value={currentTableName}
        placeholder={defaultTableName}
        dataTestId={"append-table-editor-rename"}
        status={validation.status}
        message={validation.errorMsg}
        inputOnly={false}
        size={"medium"}
        label={appstr("Table Name")}
      />
    </Flex>
  );
});
